"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var main =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:row;justify-content:space-between;padding:7px 10px;margin:0 auto;position:relative;@media (max-width:600px){max-width:340px !important;}");
var buttonWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:column;align-items:center;z-index:1;position:relative;@media (min-width:600px){padding:0px 10px;}");
var greyBar =
/*#__PURE__*/
(0, _reactEmotion.css)("position:absolute;top:0px;height:32px;width:100%;background:#f1f5fb;border-radius:30px;left:0;");
var textDiv =
/*#__PURE__*/
(0, _reactEmotion.css)("padding-top:15px;font-family:ProximaNova;font-size:16px;color:#929dae;text-align:center;");
var buttonDiv =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;align-content:center;&:first-child{padding-left:0px;}&:last-child{padding-right:0px;}");
var alignButtons =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:row;justify-content:space-between;");
var checkbox =
/*#__PURE__*/
(0, _reactEmotion.css)(".checkboxLabel &{border-radius:10px;}");
var _default = {
  main: main,
  buttonWrapper: buttonWrapper,
  greyBar: greyBar,
  textDiv: textDiv,
  buttonDiv: buttonDiv,
  checkbox: checkbox,
  alignButtons: alignButtons
};
exports.default = _default;